<template>
  <div>
    <div class="box shadow trasparent">
      <figure class="avatar">
        <!-- <img :src="contact.image" alt="Logo cnos-fap" style="width:80px;" /> -->
        <avatar
          :contactId="contact.id"
          :width="80"
          :height="80"
          :borderRadius="40"
        />
      </figure>

      <div>
        <div class="media shadow services" style="margin: -5px 0px 20px 0px">
          <div class="media-content">
            <div class="content" style="padding: 5px">
              <p>
                <strong>{{ contact.nickname }}</strong>
                <br />
                <small
                  class="is-size-7"
                  v-if="contact._emails && contact._emails[0]"
                  >{{ contact._emails[0].email }}</small
                >
              </p>
            </div>
          </div>
          <div class="media-right" style="padding: 12px">
            <a class="button is-danger is-outlined" @click="logout()">Esci</a>
          </div>
        </div>

        <div v-for="service in services" :key="service.name">
          <article
            class="media shadow services"
            @click="gotoUrl(service, service.url)"
            :class="serviceClass(service)"
          >
            <figure class="media-left">
              <p class="image is-64x64">
                <img :src="service.image" alt="Placeholder image" />
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <strong>{{ service.title }}</strong>
                <br />
                <small>{{ service.subtitle }}</small>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '@/service/auth'
import Avatar from '@/components/avatar'
import { TZB_WEB_PUB, TZB_MOBILE_PUB } from '@/service/config'
export default {
  components: {
    Avatar,
  },
  data() {
    return {
      contact: {},
      tzbPresence: false,
      services: [
        {
          name: 'tazebao',
          enable: true,
          url: TZB_WEB_PUB,
          image: '../../static/tzb-icon.png',
          title: 'Tazebao Desktop',
          subtitle: 'Registro Elettronico e gestione corsi',
        },
        {
          name: 'extranet',
          enable: true,
          url: 'http://extranet.cnosfap.net/googleauth.php?info=TzbInfo',
          image: '../../static/m3.png',
          title: 'Extranet',
          subtitle: 'Gestione bollature dipendenti, DB professional',
        },
        {
          name: 'organization',
          enable: true,
          url:
            'https://sites.google.com/a/cnosfap.net/processicnos/presentazione-dell-associazione',
          image: '../../static/piemonte.png',
          title: 'Sistema Organizzativo',
          subtitle: 'Sistema Qualità e Accreditamento',
        },
        {
          name: 'tzbpresence',
          enable: true,
          url: TZB_MOBILE_PUB,
          image: '../../static/tzb-presence.png',
          title: 'Presenze rapide',
          subtitle: 'App mobile per rilevamento rapido presenze',
        },
        {
          name: 'siq',
          enable: true,
          url: 'http://siq.cnosfap.net/index.php?info=TzbInfo',
          image: '../../static/siq.png',
          title: 'Sistema Informativo Qualità',
          subtitle: 'Archivio anni precedenti al 2019',
        },
        {
          name: 'tazebot',
          enable: true,
          url: 'https://t.me/tazebaobot',
          image: '../../static/tazebot.png',
          title: 'Tazebao BOT',
          subtitle: 'Telegram BOT per la comunicazione con le famiglie',
        },
      ],
    }
  },

  async created() {
    try {
      const contact = await Auth.login()
      this.contact = contact
      if (contact) {
        this.tzbPresence =
          contact.userAuth.auth.CoursePresence.rapidPresenceEnable
      }
    } catch (error) {
      this.$router.replace({
        name: 'login',
        query: {
          message: `Login fallito.\nCausa: ${error.message}`,
        },
      })
    }
  },

  methods: {
    logout() {
      Auth.logout()
      this.$router.push({
        name: 'login',
      })
    },

    gotoUrl(service, url) {
      if (service.enable) {
        if (service.name === 'tzbpresence') {
          if (this.tzbPresence === true) {
            window.location.href = url
          }
        } else {
          window.location.href = url
        }
      }
    },

    serviceClass(service) {
      let style = ''
      if (service.enable) {
        if (service.name === 'tzbpresence') {
          if (this.tzbPresence === true) {
            style = 'enabled'
          } else style = 'disabled'
        } else {
          style = 'enabled'
        }
      } else style = 'disabled'
      return style
    },
  },
}
</script>

<style scoped>
.services {
  background-color: #ffffff;
  margin: 10px 0 10px 0;
  padding: 5px;
  border-style: solid;
  border-width: 2px;
  border-color: transparent;
  border-radius: 5px;
}

.enabled {
  background: #ffffff;
}

.enabled:hover {
  border-style: solid;
  border-width: 2px;
  border-color: #6041bf;
}

.disabled {
  background: #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/pages/Landing.vue